module.exports = __webpack_public_path__ + "static/improvement-bd105d637e93e285cd7491931466838a.png";